import paymentReportReducer from './PaymentReportReducer';
import otherPaymentReportReducer from './OtherPaymentReportReducer';
import dailyReportReducer from './dailyReportReducer';
import checkPostingReducer from './checkPostingReducer';
import claimAdjustmentReducer from './claimAdjustmentReducer';
import inventoryReportReducer from './inventoryReportReducer';

const paymentReportReducers = {
  paymentReport: paymentReportReducer,
  otherPaymentReport: otherPaymentReportReducer,
  dailyReport: dailyReportReducer,
  checkPosting: checkPostingReducer,
  claimAdjustment: claimAdjustmentReducer,
  inventoryReport: inventoryReportReducer,
};

export default paymentReportReducers;
